import React from 'react';
import { useSelector } from 'react-redux';

import { IApplicationState } from '@store';

import { useTranslation } from 'react-i18next';
import './UploaderVersionBanner.scss';

const UploaderVersionBanner: React.FC = () => {
  //here month is the index starting from 0(jan) to 11(dec)
  //Dont show the banner after 31st Dec 2023
  const bannerDurationDate = new Date(2023, 11, 31, 23, 59, 59);
  const now = new Date();

  const { t } = useTranslation();
  const { builds } = useSelector((state: IApplicationState) => ({
    builds: state.builds?.builds,
  }));

  return (
    <div>
      {!builds?.length || now.getTime() > bannerDurationDate.getTime() ? (
        <div></div>
      ) : (
        <div className='m-0 uploader-version-banner'>
          {t('upload_uploaderversion_warningBanner', {
            uploaderversion: builds[0].version,
          })}
        </div>
      )}
    </div>
  );
};

export default UploaderVersionBanner;
